import * as tslib_1 from "tslib";
import { infoBarAddHandler, infoBarRemoveHandler } from './infoBarHandlers';
import trySaveMessage, { waitForActiveSaving } from '../actions/trySaveMessage';
import { lazyCreateAttachmentsViaQueueManager } from 'owa-attachment-well-data';
import { getCurrentTableMailboxInfo } from 'owa-mail-mailboxinfo';
import triggerPolicyTips from 'owa-mail-compose-store/lib/actions/triggerPolicyTips';
import { isMailFeatureEnabled } from 'owa-mail-feature-flags';
function createAttachmentsHandler(files, isInline, composeViewState, shouldShare, isHiddenInline, processInlineImageBeforeUploadFunc, attachmentInfoBarAddHandler, attachmentInfoBarRemoveHandler, onFinish) {
    lazyCreateAttachmentsViaQueueManager.import().then(function (createAttachmentsViaQueueManager) {
        var filesQueuedToAttach = createAttachmentsViaQueueManager(composeViewState.attachmentWell, tslib_1.__assign({}, composeViewState.itemId, { mailboxInfo: getCurrentTableMailboxInfo() }), files, attachmentInfoBarAddHandler
            ? attachmentInfoBarAddHandler
            : infoBarAddHandler(composeViewState), attachmentInfoBarRemoveHandler
            ? attachmentInfoBarRemoveHandler
            : infoBarRemoveHandler(composeViewState), isInline, shouldShare, isHiddenInline, onFinish);
        if (isInline) {
            var fileLength = filesQueuedToAttach.length;
            var inlineAttachmentsLength = composeViewState.attachmentWell.inlineAttachments.length;
            for (var i = 0; i < fileLength; i++) {
                // Get the last fileLength number of inline attachments
                // since they are the new ones created from above createAttachmentsViaQueueManager.
                var attachmentState = composeViewState.attachmentWell.inlineAttachments[inlineAttachmentsLength - fileLength + i];
                processInlineImageBeforeUploadFunc &&
                    processInlineImageBeforeUploadFunc(attachmentState.placeholderId, filesQueuedToAttach[i]);
            }
        }
    });
}
export default function createAttachments(files, isInline, composeViewState, shouldShare, isHiddenInline, processInlineImageBeforeUploadFunc, attachmentInfoBarAddHandler, attachmentInfoBarRemoveHandler, onFinish) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var _a;
        return tslib_1.__generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = !composeViewState.itemId;
                    if (!_a) return [3 /*break*/, 2];
                    return [4 /*yield*/, waitForActiveSaving(composeViewState)];
                case 1:
                    _a = !(_b.sent());
                    _b.label = 2;
                case 2:
                    if (!_a) return [3 /*break*/, 4];
                    return [4 /*yield*/, trySaveMessage(composeViewState)];
                case 3:
                    _b.sent();
                    _b.label = 4;
                case 4:
                    createAttachmentsHandler(files, isInline, composeViewState, shouldShare, isHiddenInline, processInlineImageBeforeUploadFunc, attachmentInfoBarAddHandler, attachmentInfoBarRemoveHandler, function (attachmentId) {
                        if (onFinish) {
                            onFinish(attachmentId);
                        }
                        if (isMailFeatureEnabled('cmp-encryption')) {
                            triggerPolicyTips(composeViewState, 8 /* AttachmentAdded */);
                        }
                    });
                    return [2 /*return*/];
            }
        });
    });
}
//# sourceMappingURL=createAttachments.js.map